import React from 'react';
import ReactModal from 'react-modal';
import { defineMessages, FormattedMessage, 
    // intlShape, 
    injectIntl } from 'react-intl';
// import { Icon } from 'antd';
import { Icon } from "@chakra-ui/react";
import './drawerComponents.css';
import bindAll from 'lodash.bindall';
import wifiConnectIcon from './wifiConnectIcon.png'
import wifiConnectLoading from './wifiConnectLoading.png'



const messages = defineMessages({
});

// wifi连接

class WifiConnectLoadModal extends React.Component {

    constructor(props) {
        super(props);
        bindAll(this, [
        ]);
    }

    componentDidMount() {
    }
    render() {
        const { intl, ...props } = this.props;
        return (
            <ReactModal 
                isOpen
                overlayClassName="modalOverlay"
                className="modalContentLoad"
                ariaHideApp={false}
            >
                <div>
                    <div className="wifiConnectLoading">
                        <div className="wifiConnectLoadingImg">
                            <img src={wifiConnectLoading} className="wificonnectLoadback" />
                            <img src={wifiConnectIcon} className="wificonnectLoadIcon" />
                        </div>
                        <div className="wifiConncetWord">
                            <FormattedMessage
                                defaultMessage="Do not close this page!"
                                description="Do not close this page!"
                                id="gui.homePage.camNousWifiConnectLoad"
                            />
                        </div>
                    </div>
                </div>
            </ReactModal>
        );
    }
}
WifiConnectLoadModal.propTypes = {
    // intl: intlShape
};

export default injectIntl(WifiConnectLoadModal);
